import { TMoney } from 'src/types';

const AFFILIATE_COMMISSION_RATE = 0.15;
const AFFILIATE_CURRENCY_CONVERSION_RATE = 0.05;

const calculateEstimatedAffiliateAmount = (minPrice: { price?: TMoney; masterPrice: TMoney }, commissionRate: number, uncappedEarning?: boolean): TMoney => {
  const price = minPrice.price || minPrice.masterPrice

  const commissionAmount = Number(price.amount) * (commissionRate / 100)

  let affiliateAmount = commissionAmount * AFFILIATE_COMMISSION_RATE
  affiliateAmount = affiliateAmount * (1 - AFFILIATE_CURRENCY_CONVERSION_RATE)

  return {
    currency: price.currency,
    amount: affiliateAmount
  }
}

export default calculateEstimatedAffiliateAmount
